import { Button, Result } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

import { ArrowLeftOutlined, HomeOutlined } from "@ant-design/icons";
const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <div className="max-w-md w-full px-6">
        <Result
          status="404"
          title={
            <span className="text-gray-800 dark:text-white text-4xl font-bold">
              404
            </span>
          }
          subTitle={
            <span className="text-gray-600 dark:text-gray-300 text-lg">
              Trang bạn tìm kiếm không tồn tại
            </span>
          }
          extra={
            <div className="space-y-3">
              <Button
                type="primary"
                size="large"
                icon={<HomeOutlined />}
                onClick={() => navigate("/dashboard")}
                className="w-full"
                style={{
                  backgroundColor: "var(--primary-color)",
                  borderColor: "var(--primary-color)",
                }}
              >
                Về trang chủ
              </Button>
              <Button
                type="default"
                size="large"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                className="w-full bg-white dark:bg-gray-700 text-gray-800 dark:text-white border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                Quay lại
              </Button>
            </div>
          }
        />

        <div className="text-center mt-8">
          <p className="text-gray-500 dark:text-gray-400 text-sm">
            Có thể bạn đang tìm kiếm:
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-3">
            <Button
              type="link"
              size="small"
              onClick={() => navigate("/dashboard")}
              className="text-primary-500 hover:text-primary-600"
            >
              Dashboard
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => navigate("/profile")}
              className="text-primary-500 hover:text-primary-600"
            >
              Profile
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => navigate("/dashboard/setting")}
              className="text-primary-500 hover:text-primary-600"
            >
              Settings
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
